module.exports = __webpack_public_path__ + "img/567x600px-Tarsashaz.1c37bb9b.jpg";